import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpResponse
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { NotificationService, CommonDataSharedService, CommonRequestResponseService } from 'app/services';
import { LoginService } from 'app/services/login.service';
@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    private requests = [];
    constructor(
        public errorDialogService: NotificationService,
        private commonDataSharedService: CommonDataSharedService,
        private notificationService: NotificationService,
        private loginService: LoginService,
        private _commonRequestResponseService: CommonRequestResponseService
    ) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (localStorage.getItem('loginUserData')) {
            const token: string = JSON.parse(localStorage.getItem('loginUserData')).token;
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
        }
        this.commonDataSharedService.loginDatas.subscribe(token => {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
        })


        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

        return Observable.create(observer => {
            const subscription = next.handle(request)
                .subscribe(
                    event => {
                        if (event instanceof HttpResponse) {
                            observer.next(event);
                            if (event.body && event.body.token) {
                                const localData = JSON.parse(localStorage.getItem('loginUserData'));
                                if (localData) {
                                    localData.token = event.body.token;
                                    localStorage.setItem('loginUserData', JSON.stringify(localData));
                                }
                            }
                        }
                    },
                    err => {
                        switch (err.status) {
                            case 401:
                                if (this._commonRequestResponseService.loginDetail.userId) {
                                    observer.complete();
                                    this.loginService.logout(true);
                                    this.notificationService.show('error', 'Your request is Unauthorized.');
                                    break;
                                }
                                return;
                            case 404:
                                this.notificationService.show('error', 'Your request is Unauthorized.');
                                break;
                            case 502:
                                this.notificationService.show('error', 'Invalid Response from the Server.');
                                this.loginService.logout();
                                break;
                            case 403:
                                this.notificationService.show('error', 'Access Forbidden to this request.');
                                break;
                        }


                        observer.error(err);
                    },
                    () => {

                        observer.complete();
                    });

            return () => {
                subscription.unsubscribe();
            };
        })
    }
}
